module.exports = global["ko"] = require("-!.\\knockout-latest.debug.js");